import { createDecartClient, models } from "./decart-sdk.bundle.js";

const config = window.DecartTryOnConfig || {};
const WORKER_URL = config.workerUrl;
const GARMENT_IMAGE = config.garmentImageUrl && config.garmentImageUrl.startsWith("//")
     ? "https:" + config.garmentImageUrl
     : config.garmentImageUrl;
const PROMPT = config.prompt || "Substitute the current top with this garment";

const openBtn = document.getElementById("decart-tryon-btn");
const overlay = document.getElementById("decart-tryon-overlay");
const closeBtn = document.getElementById("decart-tryon-close");
const startBtn = document.getElementById("decart-tryon-start");
const stopBtn = document.getElementById("decart-tryon-stop");
const pipBtn = document.getElementById("decart-tryon-pip");
const video = document.getElementById("decart-tryon-video");
const statusEl = document.getElementById("decart-tryon-status");

let localStream = null;
let realtimeClient = null;

function setStatus(text, kind) {
  if (!statusEl) return;
  statusEl.textContent = text;
  statusEl.className = "decart-tryon-status" + (kind ? " " + kind : "");
}

function openModal() {
  if (!overlay) return;
  overlay.hidden = false;
  setStatus('Click "Start camera" to try this on.');
}

function closeModal() {
  stopSession();
  if (overlay) overlay.hidden = true;
}

function stopSession() {
  if (realtimeClient) {
    realtimeClient.disconnect();
    realtimeClient = null;
  }
  if (localStream) {
    localStream.getTracks().forEach((t) => t.stop());
    localStream = null;
  }
  if (video) video.srcObject = null;
  if (startBtn) startBtn.disabled = false;
  if (stopBtn) stopBtn.disabled = true;
  if (pipBtn) pipBtn.disabled = true;
}

async function startSession() {
  if (!WORKER_URL || WORKER_URL.indexOf("PASTE_YOUR") === 0) {
    setStatus("Try-on isn't fully set up yet (missing Worker URL). Store owner: edit snippets/decart-tryon.liquid.", "error");
    return;
  }
  if (!GARMENT_IMAGE) {
    setStatus("No product image available to try on.", "error");
    return;
  }

  startBtn.disabled = true;
  setStatus("Requesting camera access…");

  try {
    localStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
  } catch (err) {
    startBtn.disabled = false;
    if (err.name === "NotAllowedError") {
      setStatus("Camera access was denied. Please allow camera access and try again.", "error");
    } else if (err.name === "NotFoundError") {
      setStatus("No camera was found on this device.", "error");
    } else {
      setStatus("Camera error: " + err.message, "error");
    }
    return;
  }

  setStatus("Connecting…");

  try {
    const tokenRes = await fetch(WORKER_URL, { method: "POST" });
    if (!tokenRes.ok) throw new Error("Could not start a try-on session (server error).");
    const { apiKey } = await tokenRes.json();
    if (!apiKey) throw new Error("Could not start a try-on session (no token returned).");

    const client = createDecartClient({ apiKey });
    const model = models.realtime("lucy-vton-latest");

    realtimeClient = await client.realtime.connect(localStream, {
      model,
      mirror: "auto",
      onRemoteStream: (remoteStream) => {
        video.srcObject = remoteStream;
      },
      onError: (err) => {
        setStatus("Error: " + (err.message || err), "error");
      },
      onDisconnect: () => {
        setStatus("Session ended.", "");
        stopSession();
      },
      initialState: {
        prompt: { text: PROMPT, enhance: true },
        image: GARMENT_IMAGE,
      },
    });

    realtimeClient.on("connectionChange", (state) => {
      if (state === "connected" || state === "generating") {
        setStatus("Live — you should see yourself wearing it.", "ok");
      } else if (state === "reconnecting") {
        setStatus("Reconnecting…", "error");
      }
    });

    realtimeClient.on("error", (err) => {
      setStatus("Error: " + (err.message || err), "error");
    });

    stopBtn.disabled = false;
    if (pipBtn) pipBtn.disabled = false;
  } catch (err) {
    startBtn.disabled = false;
    stopSession();
    setStatus("Error: " + (err.message || err), "error");
  }
}

if (pipBtn) {
  pipBtn.addEventListener("click", async () => {
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else if (video.requestPictureInPicture) {
        await video.requestPictureInPicture();
      } else {
        setStatus("Picture-in-picture isn't supported in this browser.", "error");
      }
    } catch (err) {
      setStatus("Couldn't open picture-in-picture: " + (err.message || err), "error");
    }
  });
}

if (openBtn) openBtn.addEventListener("click", openModal);
if (closeBtn) closeBtn.addEventListener("click", closeModal);
if (startBtn) startBtn.addEventListener("click", startSession);
if (stopBtn) stopBtn.addEventListener("click", stopSession);

window.addEventListener("beforeunload", stopSession);
